<!--
Author: TangChen
Date: 2018-12-24
Desc: 私募/专户理财投资者认证资料上传页
 -->
<!--
Author: TangChen
Date: 2018-11-07
Desc: 投资者资料上传，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-private-upload bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row v-if="!hadUpload" class="private-upload">
            <el-row class="up-list" :span="24">
                <el-form ref="img" :model="img" :rules="rules">
                    <el-form-item label="申请合格投资者类型：" prop="cate" class="form-text">
                        <el-radio-group v-model="img.cate">
                            <el-radio label="1" name="sell">
                                合格投资者
                            </el-radio>
                            <el-radio label="2" name="sell">
                                豁免投资者
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="" class="form-text">
                        <el-alert
                            title="注意：上传的图片大小每张不能超过1.5M，格式类型只支持bmp，jpg，jpeg，png"
                            type="warning"
                            show-icon
                            :closable="false"
                        />
                    </el-form-item>
                    <el-form-item label="请上传相关申请转换材料:" class="form-text tit" />
                    <el-form-item label="" prop="asset">
                        <p class="up-list-mes">
                            金融资产不低于300万元或者最近三年个人年均收入不低于50万元的个人
                        </p>
                        <div class="img-up-list el-upload-list--picture-card">
                            <div v-if="imgBase64.asset" class="el-upload-list__item-actions">
                                <i class="el-icon-zoom-in" v-on:click="handlePictureCardPreview('asset')" />
                                <i class="el-icon-delete" v-on:click="delImg('asset')" />
                            </div>
                            <el-input
                                ref="asset"
                                v-model="img.asset"
                                type="file"
                                name="asset"
                                :accept="accept"
                                v-on:change="getImgBase"
                            />
                            <div class="img-up">
                                <img v-if="imgBase64.asset" :src="imgBase64.asset">
                                <i v-if="!imgBase64.asset" class="el-icon-plus" />
                                <span v-if="!imgBase64.asset" class="img-text">资产证明</span>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="" class="btn-center">
                        <el-button type="primary" class="medium" v-on:click="submitInfo()">
                            上传
                        </el-button>
                        <el-button class="medium" v-on:click="$router.back()">
                            还未准备好
                        </el-button>
                    </el-form-item>
                </el-form>
                <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl">
                </el-dialog>
            </el-row>
        </el-row>
        <result
            v-if="hadUpload"
            :result="resultObj"
            v-on:login-now="$router.push({name: 'home'})"
            v-on:return-login="$router.push({name: 'info'})"
        />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import result from "@/components/layout/result.vue";
export default {
    name: "PrivateUpload",
    components: {
        result
    },
    mixins: [mixin],
    data () {
        return {
            dialogImageUrl: "",
            dialogVisible: false,
            hadUpload: false,
            accept: "image/bmp,image/png,image/jpg,image/jpeg",
            img: {
                asset: "",
                cate: "1"
            },
            resultObj: {// 结果页面信息
                cla: "register-success",
                msg: "转换资料提交成功！",
                btnMsg: "您的投资者类型转换申请提交成功，请耐心等待审核结果",
                btnL: {
                    text: "返回首页",
                    event: "login-now"
                },
                btnR: {
                    text: "进入信息中心",
                    event: "return-login"
                }
            },
            imgBase64: {},
            rules: {
                asset: [
                    { required: true, message: "请选择资产证明文件上传", trigger: "change" }
                ]
            },
            upload_url: "acct/changetype/upload",
            uploadForm: new FormData()
        };
    },
    methods: {
        handlePictureCardPreview (filename) {
            this.dialogImageUrl = this.imgBase64[filename];
            this.dialogVisible = true;
        },
        submitInfo () {
            const _this = this;
            _this.$refs.img.validate(valid => {
                if (valid) {
                    this.$req({
                        method: "POST",
                        url: _this.upload_url,
                        timeout: 20000,
                        data: _this.uploadForm,
                        headers: { "Content-Type": "multipart/form-data" }
                    }).then(res => {
                        if (res.code === "0000000") {
                            _this.hadUpload = true;
                        } else {
                            this.$message.error(res.msg);
                        }
                    }).catch(() => { });
                } else {
                    return false;
                }
            });
        },
        getImgBase () {
            const _this = this;
            const event = window.event;
            const file = event.target.files[0];
            if (!file) {
                this.delImg(event.target.name);
                return false;
            }
            if (file.size > 5 * 1024 * 1024) {
                this.img[event.target.name] = "";
                this.$message.warning("上传文件大小超过限制大小5M，不能上传");
                return;
            }
            const reader = new FileReader();
            // 转base64
            reader.onload = function (e) {
                _this.$set(_this.imgBase64, event.target.name, e.target.result);
            };
            try{
                this.uploadForm.delete(event.target.name);
            }catch (e) {
                console.log(e);
            }
            this.uploadForm.append(event.target.name, file);
            reader.readAsDataURL(file);
        },
        // 删除图片
        delImg (index) {
            this.imgBase64[index] = "";
            if (this.img[index]) {
                this.img[index] = "";
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
/*用户信息 */
.bizcomp-private-upload {
    .private-upload {
        padding: 20px;
        .comp-result {
            padding-bottom: 50px;
        }
        .btn-center {
            text-align: center;
        }
        .el-form-item.form-text {
            margin-bottom: 0;
            .el-form-item__label {
                font-size: $f16;
            }
            &.tit .el-form-item__label {
                color: $text-color3;
            }
            .el-alert__content {
                line-height: 20px;
            }
        }
        .up-list {
            .up-list-mes {
                font-size: $f16;
                color: $text-color2;
                line-height: 30px;
            }
            .img-up-list {
                margin-top: 20px;
                display: inline-block;
                position: relative;
                .el-upload-list__item-actions {
                    z-index: 100;
                    i {
                        font-size: $f24;
                        cursor: pointer;
                    }
                    i:last-of-type {
                        margin-left: 20px;
                    }
                }
                .el-input {
                    position: absolute;
                    top: 10px;
                    left: 0;
                    opacity: 0;
                    z-index: 10;
                }
                .img-up,
                .el-input .el-input__inner {
                    width: 240px;
                    height: 150px;
                    line-height: 150px;
                    cursor: pointer;
                }
                .img-up {
                    text-align: center;
                    border: 3px dashed $border-color4;
                    border-radius: 10px;
                    background-color: $bg1;
                    overflow: hidden;
                    color: $text-color3;
                    img {
                        width: 240px;
                        height: 150px;
                        display: inline-block;
                    }
                }
                .img-text {
                    vertical-align: middle;
                    font-size: $f20;
                }
                .el-icon-plus {
                    vertical-align: middle;
                    font-size: $f26;
                    margin-right: 7px;
                    color: inherit;
                    font-weight: bold;
                }
            }
            .img-up-box {
                .img-up-list {
                    vertical-align: middle;
                    &:last-of-type {
                        margin-left: 24px;
                    }
                }
            }
        }
    }
}
</style>
